<template>
    <div class="time-zone">
        <el-select :value="zone" placeholder="请选择" @change="changeTimeZone" style="width: 106px;" size="mini">
            <el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>
            <el-option label="时区-UTC" value="UTC">时区-UTC</el-option>
        </el-select>
        <el-date-picker
            size="mini"
            class="ml6"
            v-model="range"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeRangeTime"
            :clearable="false"
            :editable="false"
            style="width: 220px;">
        </el-date-picker>
        <el-button type="primary" size="mini" class="ml10" @click="handleClick" :loading="addLoading" v-if="pageFuncNames.includes('add_ad')">+ 创建广告</el-button>
    </div>
</template>

<script>
    import dateShortcuts from './dateShortcuts.js';

    export default {
        name: "TimeZone",
        props:{
            zone:String,
            rangeTime:Array,
            pageFuncNames:Array,
            addLoading:Boolean,
        },
        data(){
            return {
                range:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        dateShortcuts.today,
                        dateShortcuts.yesterday,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                        dateShortcuts.last30,
                        dateShortcuts.thisWeek,
                        dateShortcuts.thisMonth,
                        dateShortcuts.thisQuarter,
                    ],
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                },
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.range = [...this.rangeTime];
            })

        },
        methods:{
            handleClick(){
                this.$emit('click-add');
            },
            changeTimeZone(val){
                this.$emit('change',val,this.range);
                console.log('changeTimeZone',val);
                this.$store.commit('apple/SET_TIME_ZONE',val);
            },
            changeRangeTime(range){
                console.log('change time',range);
                this.$emit('change',this.zone,this.range);
            },

        }
    }
</script>

<style lang="scss" scoped>
  
</style>
